import type { User } from '@/portalApi'
import getEnv from '@/util/env'
import * as Sentry from '@sentry/vue'
import { type App } from 'vue'

export const beforeSend = (event: Sentry.ErrorEvent): Sentry.ErrorEvent => {
  if (!event.tags) event.tags = {}
  // Add global tags to every event
  return event
}

const registerSentry = (app: App<Element>, dsn: string) => {
  Sentry.init({
    app,
    beforeSend,
    dsn,
    attachProps: true,
    attachStacktrace: true,
    environment: getEnv('VITE_SUBDOMAIN') || '<none>',
    ignoreErrors: [
      // Ignore network based errors, let emit from original service instead
      /axios/,
      'AxiosError',
      'FetchError',
      /NetworkError/,
      'Network Error',
      'Request failed with status code',
      'PortalApiError',
    ],
    initialScope: {
      tags: {
        'account.id': getEnv('VITE_AWS_ACCOUNT_ID'),
        'account.region': getEnv('VITE_AWS_REGION'),
        'account.stage': getEnv('VITE_STAGE_NAME') || '<none>',
        'account.platform': 'AWS'
      }
    },
    integrations: [
      Sentry.vueIntegration(),
      Sentry.extraErrorDataIntegration(),
    ],
    normalizeDepth: 15,
    sendDefaultPii: false,
    release: import.meta.env.PACKAGE_VERSION,
    replaysOnErrorSampleRate: 0.001,
    tracePropagationTargets: [
      getEnv('VITE_API_BASE_URL')
    ],
    tracesSampleRate: 0.5
  })
}

// When user logs in or you have user data available
export const setUserContext = (user: User & { name: string } | undefined) =>
  Sentry.setUser(user ? {
    id: user.id,
    email: user.email || 'n/a'
  } : null)

export default registerSentry